export default __webpack_public_path__ + "static/bg_form-6344b96657ace277d738d1d719076d51.png";